module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n1n4r8r-fb17564135cc7b2f7d1c4135551a699c.svg";